import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faServer, faPlus, faXmark, faCircleNotch, faBolt } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import SubscribeCard from "../components/SubscribeCard";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';
import { useUser } from "../utils/UserContext";
import Modal from 'react-modal';
import { toast } from 'react-hot-toast';
import { Link } from 'react-router-dom'

function Subscribe() {
  const { user } = useUser();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [subscribe_name, setSubscribe_name] = useState();
  const [amount, setAmount] = useState();
  const [duration, setDuration] = useState();
  const [percentage, setPercentage] = useState();
  const [features, setFeatures] = useState();

  useEffect(() => {
    if(subscribe_name && duration && amount && percentage && features){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [subscribe_name, duration, amount, percentage, features]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [see, setSee] = useState(true);
  const usdbal = user?.subscription_balance;
  const [plans, setPlans] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchPlan: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setPlans(data.plans);
      }
    })
    .catch(err => {
      console.log(err);
        console.error('Error fetching plans!')
    })
  }, [user]);

  const AddSubscription = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/subscription.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_addsubscribe: true, subscribe_name : subscribe_name, duration : duration, amount : amount, percentage : percentage, features : features})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
            window.location.href = "subscribe";
          }, 2000);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Subscribe" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Subscribe" icon={<FontAwesomeIcon icon={faServer} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-12">
                <div className="mycard mt-2 mb-4">
                  <div className="d-md-flex justify-content-between mb-4">
                    <div>
                        <div className="d-flex justify-content-between align-items-center">
                            <p className="text-secondary fw-bold mb-0">Total Subscription Balance: <FontAwesomeIcon icon={(see === true)?faEye:faEyeSlash} className="ms-2" style={{fontSize: '16px'}} onClick={() => {
                            setSee(see === true ? false : true);
                            }}/></p>
                        </div>
                        <h2 className="fs-4 fw-bold">{see ? `${getCurrencySymbol(user?.currency)}${formatCurrency(usdbal * rate)}` : '******'}</h2>
                    </div>
                    {/* <Link to="/deposit" state={{route: 'subscription'}} className="noLink">
                      <div className="px-3 py-2 d-flex align-items-center rounded-2" style={{backgroundColor: '#ffffff06',textDecoration:'none'}}>
                        <FontAwesomeIcon className="text-prime lh-1 me-2" icon={faBolt} style={{fontSize:'14px'}} />
                        <p className="mb-0 fw-semibold text-prime" style={{fontSize: '14px'}}>Deposit</p>
                      </div>
                    </Link> */}
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="text-secondary fw-bold mb-0">Current subscription:: {user?.subscription}</p>
                    <p className="text-prime mb-0 fw-bold" style={{cursor: 'pointer'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(user?.subscription_amount)}</p>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-between">
                  <h5 className="mb-4 fw-bold text-white ms-2">Subscriptions Plans</h5>
                  {user?.user_type === "adminface" && (
                    <div className="myBtn d-inline-block bg-prime px-3" style={{fontSize: '14px'}} onClick={() => setIsOpen(true)}><FontAwesomeIcon icon={faPlus} style={{fontSize: '12px'}} /> Add Plan</div>
                  )}
                </div>
                <div className="row">
                  {plans.map((plan) => (
                    <div className="col-xxl-3 col-lg-4 col-6 col-12" key={plan.id}>
                      <SubscribeCard key={plan.id} subscribe_id={plan.subscribe_id} name={plan.subscribe_name} price={plan.amount} duration={plan.duration} roi={plan.percentage} features={plan.features}/>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </main>
        </div>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>
                Add subscription plan</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Plan Name:</label>
            <div className="form-control py-2">
                <input 
                  type="text"
                  placeholder="Lite"
                  className="inputNone"
                  value={subscribe_name}
                  onChange={(e) => setSubscribe_name(e.target.value)}
                />
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                <input 
                  type="number"
                  placeholder="1000"
                  className="inputNone"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <div
                  className="fw-bold text-white d-flex align-items-center"
                  style={{
                    backgroundColor: 'rgb(30, 33, 36)',
                    borderRadius: '4px',
                    padding: '6px',
                    fontSize: '14px',
                    cursor: 'pointer' 
                  }}
                >
                  USD
                </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Duration:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                <input 
                  type="number"
                  placeholder="2"
                  className="inputNone"
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                />
                <div
                  className="fw-bold text-white d-flex align-items-center"
                  style={{
                    backgroundColor: 'rgb(30, 33, 36)',
                    borderRadius: '4px',
                    padding: '6px',
                    fontSize: '14px',
                    cursor: 'pointer' 
                  }}
                >
                  DAYS
                </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>ROI:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                <input 
                  type="number"
                  placeholder="2"
                  className="inputNone"
                  value={percentage}
                  onChange={(e) => setPercentage(e.target.value)}
                />
                <div
                  className="fw-bold text-white d-flex align-items-center"
                  style={{
                    backgroundColor: 'rgb(30, 33, 36)',
                    borderRadius: '4px',
                    padding: '6px',
                    fontSize: '14px',
                    cursor: 'pointer' 
                  }}
                >
                  %
                </div>
            </div>
            <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Features:</label>
            <textarea 
              className="inputNone form-control "
              value={features}
              onChange={(e) => setFeatures(e.target.value)}
            />
            <div className={`myBtn w-100 text-center mt-3 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? AddSubscription : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add'}</div>
        </Modal>
      </div>
    </div>
  )
}

export default Subscribe